module.exports = __webpack_public_path__ + "heart.67ebebbd.png";